import NormalCard from '../../../../components/card/normal-card';
import { getDateTimeFormatString } from '../../../../components/common/common-helper';
import GeneralRateRow from '../../../../components/pricing/general-rate-row';
import AccordionWrapper from '../../../../components/wrapper/accordion-wrapper';
import { formatCurrency } from '../../../../shared/utility';
import { getFormattedExtensionRates } from '../../../../shared/utility/pricing-utility';
import { convertFoxApiDateToStr } from '../../fox-reservation/fox-res-helper';

function AdditionalChargeDetails(props) {
    const { rentalExtension, isExpand, contClasses } = props;
    const formattedRates = getFormattedExtensionRates(rentalExtension?.rates || []);
    const extendedBy = rentalExtension?.extendedBy;
    const extensionDate = convertFoxApiDateToStr(rentalExtension?.returnDate, getDateTimeFormatString(true, false, true));
    const previousReturnDate = convertFoxApiDateToStr(rentalExtension?.previousReturnDate, getDateTimeFormatString(true, false, true));
    const extendedOn = convertFoxApiDateToStr(rentalExtension?.extendedOn, getDateTimeFormatString(true, false, true));
    return (
        <NormalCard title={`Extension Date: ${extensionDate}`} contClasses={contClasses}>
            <AccordionWrapper title={`Additional Charges: ${formatCurrency(rentalExtension?.totalAuth)}`} isExpand={isExpand} containerClass="accordion-common-container">
                <div className='extend-pricing-container'>
                    <div className='flax-column'>
                        <div className='flex-row'>
                            <label className='w-130 font-bold'>New Return Date</label>
                            <label>{extensionDate}</label>
                        </div>
                        <div className='flex-row'>
                            <label className='w-130 font-bold'>Previus Return Date</label>
                            <label>{previousReturnDate}</label>
                        </div>
                        <div className='flex-row'>
                            <label className='w-130 font-bold'>Extended On</label>
                            <label>{extendedOn}</label>
                        </div>
                        <div className='flex-row'>
                            <label className='w-130 font-bold'>Extended By</label>
                            <label>{extendedBy?.firstName + " " + extendedBy?.lastName}</label>
                        </div>
                        <div className='flex-row'>
                            <label className='w-130 font-bold'>Total Tax</label>
                            <label>{formatCurrency(rentalExtension?.totalTaxes)}</label>
                        </div>
                        <div className='flex-row'>
                            <label className='w-130 font-bold'>Total Auth</label>
                            <label>{formatCurrency(rentalExtension?.totalAuth)}</label>
                        </div>
                        <hr />
                    </div>
                    {(formattedRates?.length > 0 || rentalExtension?.fees?.length > 0) &&
                        <>
                            {
                                formattedRates?.map((data) => {
                                    return <GeneralRateRow
                                        key={data?.title}
                                        title={data?.title}
                                        total={data?.subtotal}
                                    />
                                })
                            }
                            {
                                rentalExtension?.fees?.map((data) => {
                                    return <GeneralRateRow
                                        key={data?.feeDesc}
                                        title={data?.feeDesc}
                                        total={data?.fee}
                                    />
                                })
                            }

                            <GeneralRateRow
                                title="Total"
                                total={rentalExtension?.totalAuth && rentalExtension?.totalAuth}
                                contClasses="card-value-container general-total bg-input"
                            />
                        </>
                    }
                </div>
            </AccordionWrapper>
        </NormalCard>
    )
}

export default AdditionalChargeDetails